import { useAdFree } from 'hooks/adFree'

// import CustomAd from 'components/advertisments/CustomAd' // Unused since we're using a standard ad on mobile
import Link from 'components/elements/Link'
import Icon from 'components/elements/Icon'

import styles from './inhouseFixedAd.module.scss'

const InhouseFixedAd = () => {
  const adFree = useAdFree()

  if (adFree) return null

  return (
    <div className={styles.desktopAdheasion} id="fixed-ad" data-ad-slot="anchor">
      <Link href="https://patreon.com/archidekt" className={styles.patreonLink} target="_blank">
        <Icon name="patreon" /> Support us on Patreon to remove ads
      </Link>
    </div>
  )
}

export default InhouseFixedAd
